import { useSyncExternalStore } from 'react'

/**
 * Posts on their way to another place (#130, 1.117.0): chosen in the chat,
 * waiting for the target.
 *
 * **Outside the page, like `jumpState`.** Between choosing and tapping the
 * target the author may go to the search on the trip's page and come back by
 * a jump; the chat page is left and drawn anew on the way. A state in it
 * would be gone, and the bar with it. Kept per trip: another trip's chat
 * shows no bar.
 */
export type Move = { tripId: number; ids: number[] }

let current: Move | null = null
const listeners = new Set<() => void>()

function emit(): void {
  for (const listener of listeners) listener()
}

export function beginMove(tripId: number, ids: number[]): void {
  current = { tripId, ids: [...ids] }
  emit()
}

export function endMove(): void {
  if (current === null) return
  current = null
  emit()
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** The move of this trip, or null. */
export function useMove(tripId: number): Move | null {
  const move = useSyncExternalStore(subscribe, () => current)
  return move !== null && move.tripId === tripId ? move : null
}
